import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Prevent the browser from auto-restoring scroll position on history
// navigation / hard reloads. We let React Router handle it, and we never
// want the UI to "jump" when a re-render happens below the fold.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

// Benign browser warning (Radix/Recharts layout) — keep it from triggering the dev error overlay.
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (e.message && e.message.includes("ResizeObserver loop")) e.stopImmediatePropagation();
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
